import ContentRenderer from '../features/ContentRendering/components/ContentRenderer';
import ContentContainer from './ContentContainer';
import { Box } from '@mui/material';
import ErrorBoundary from '../features/ContentRendering/components/ErrorBoundary';

export default function MainContentArea() {
  return (
    <Box
      component='main'
      sx={{
        width: '100%',
        paddingTop: 8,
      }}
    >
      <ErrorBoundary
        fallback={<div>Something went wrong while rendering the content.</div>}
      >
        <ContentContainer>
          <ContentRenderer />
        </ContentContainer>
      </ErrorBoundary>
    </Box>
  );
}
